export const S3_CONFIG = {
  ALLOWED_TYPES: [
    // Images
    'image/jpeg',
    'image/png',
    'image/gif',
    'image/webp',
    // Videos
    'video/mp4',
    'video/3gpp',
    'video/quicktime',
    'video/webm',
    // Audio
    'audio/aac',
    'audio/mp4',
    'audio/ogg',
    'audio/mpeg',
    'audio/amr',
    // Documents
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'text/plain',
  ],
  MAX_SIZE: 100 * 1024 * 1024, // 100MB in bytes
  PRESIGNED_URL_ENDPOINT: '/api/v1/uploads',
};
